import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeDivisionList } from './normalize';

export const fetchDivisionList = createProvider(api.fetchDivisionList)
  .andThen((res) => normalizeDivisionList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch division list aborted');
    } else {
      console.error('Fetch division list was failed:', error);
    }
    throw error;
  });
